var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"check","d":"M4.073,72.867l-3.9-3.454a.49.49,0,0,1,0-.751l.848-.751a.655.655,0,0,1,.848,0L4.5,70.237l5.623-4.983a.655.655,0,0,1,.848,0l.848.751a.49.49,0,0,1,0,.751L4.921,72.867a.655.655,0,0,1-.848,0Z","transform":"translate(0 -65.098)","fill":"#fff"}));
}

Checkbox.defaultProps = {"width":"11.991","height":"7.925","viewBox":"0 0 11.991 7.925"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
